module.exports = __webpack_public_path__ + "images/index/img08.a5ba7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuichi/img08.jpg
// module id = 2CHX
// module chunks = 21